/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCountriesCountryidLangs200,
  GetApiV1LocationCountriesCountryidLangs401,
  GetApiV1LocationCountriesCountryidLangs500,
  GetApiV1LocationCountriesCountryidLangsPathParams,
  GetApiV1LocationCountriesCountryidLangsQueryResponse,
} from "../../types/locationCountryLangController/GetApiV1LocationCountriesCountryidLangs.ts";
import { countryLangViewModelSchema } from "../countryLangViewModelSchema.ts";

export const getApiV1LocationCountriesCountryidLangsPathParamsSchema = z.object(
  {
    countryId: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCountriesCountryidLangs200Schema = z.array(
  z.lazy(() => countryLangViewModelSchema),
) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCountriesCountryidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesCountryidLangs401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCountriesCountryidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesCountryidLangs500>;

export const getApiV1LocationCountriesCountryidLangsQueryResponseSchema =
  z.lazy(
    () => getApiV1LocationCountriesCountryidLangs200Schema,
  ) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsQueryResponse>;
